import cx from "classnames";
import type { ReactNode } from "react";
import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import { spacing } from "../../../helpers/mwf/spacingHelper";
import * as styles from "./CustomAccordion.module.css";

interface ICustomAccordionSharedProps {
  children?: ReactNode;
}
type CustomAccordionSharedProps = Readonly<ICustomAccordionSharedProps>;

export const CustomAccordion = (props: CustomAccordionSharedProps) => (
  <ul className="accordion">{props.children}</ul>
);

interface ICustomAccordionCollapseProps {
  eventKey?: string;
  title: string;
  defaultCollapsed?: boolean;
  tabIndex?: number;
  customClassName?: string;
}

type CustomAccordionCollapseProps = Readonly<ICustomAccordionCollapseProps> &
  CustomAccordionSharedProps;
export const CustomAccordionCollapse = (props: CustomAccordionCollapseProps) => {
  const [isExpanded, setIsExpanded] = useState(!props.defaultCollapsed);
  const handleOnToggle = (state: boolean) => {
    setIsExpanded(!state);
  };
  const className = props.customClassName || cx("accordion-header", spacing("margin", "left", 2));
  const divId = props.eventKey ? `accordion-${props.eventKey}` : undefined;
  return (
    <li>
      <h2 className={className}>
        <button
          aria-controls={divId}
          aria-expanded={isExpanded}
          className={cx(["btn", "btn-collapse", styles.accordionToggle])}
          onClick={() => handleOnToggle(isExpanded)}
          tabIndex={props.tabIndex}
        >
          {props.title}
        </button>
      </h2>
      <Collapse in={isExpanded}>
        <div id={divId} className={cx(["accordion-body", spacing("padding", "left", 0)])}>
          {props.children}
        </div>
      </Collapse>
    </li>
  );
};

CustomAccordion.Collapse = CustomAccordionCollapse;
